module.exports = __webpack_public_path__ + "media/scanBaseF2.ee7aeae5.mp3";